/**
 * Ship display utilities - pure functions for formatting ship data for UI display.
 * These functions should NOT contain business logic that affects data sent to backend.
 */

interface ShipDisplayData {
  name?: string | null;
  mmsi?: string | null;
  imo?: string | number | null;
}

/**
 * Derives a display name from ship data - used only for UI rendering.
 * Priority: name > MMSI > IMO > "Unknown vessel"
 */
export const getShipDisplayName = (ship: ShipDisplayData): string =>
  ship.name ||
  (ship.mmsi
    ? `MMSI: ${ship.mmsi}`
    : ship.imo
      ? `IMO: ${ship.imo}`
      : 'Unknown vessel');
